import { localGetItem } from "../Utility/Services/CacheProviderService";

const setTableHeaderColor = () => {
    if (localGetItem("theme") === "default") return "#EDFFFE";
    if (localGetItem("theme") === "light") return "#E8E8E8 ";
    if (localGetItem("theme") === "dark") return "#17202A";
    return "#EDFFFE";
};
const setThemeColor = () => {
    if (localGetItem("theme") === "default") return "#04B7B1";
    if (localGetItem("theme") === "light") return "#B6B6B6";
    if (localGetItem("theme") === "dark") return "#000000";
    return "#04B7B1";
};
const setTableHeadTextColor = () => {
    if (localGetItem("theme") === "dark") return "#ffffff";
    return "#1a1917";
};
const setTableDataTextColor = () => {
    if (localGetItem("theme") === "dark") return "#ffffff";
    return localGetItem("theme") === "light" ? "#1a1917" : "#2F2A53";
};
const setConstrastColor = () => (localGetItem("theme") === "light" ? "#1a1917" : "#ffffff");
const setHoverColor = () => {
    if (localGetItem("theme") === "default") return "#E9FCF9 ";
    if (localGetItem("theme") === "light") return "#E5DEDE";
    if (localGetItem("theme") === "dark") return "#504F4F";
    return "#E9FCF9 ";
};
const setBgColor = () => (localGetItem("theme") === "dark" ? "#212F3D" : "#ffffff");
const setListItemsColor = () => (localGetItem("theme") === "dark" ? "#ffffff" : "#1a1917");
const setListIconColor = () => {
    if (localGetItem("theme") === "default") return "#04B7B1";
    if (localGetItem("theme") === "light") return "#E8E8E8 ";
    return "#ffffff";
};
const setIconBgIcon = () => "#ffffff";
const setTableBody = () => (localGetItem("theme") === "dark" ? "#121212" : "#ffffff");
const setTextColor = () => (localGetItem("theme") === "dark" ? "#ffffff" : "#000000");
const setHighlightColor = () => (localGetItem("theme") === "light" ? "#B6B6B6" : "#04B7B1");
const settabsColor = () => (localGetItem("theme") === "dark" ? "#ffffff" : "#000000");
const setTopDivbackgound = () => (localGetItem("theme") === "dark" ? "#17202A" : "#ffffff");
const setPagiantionTxtColor = () => (localGetItem("theme") === "dark" ? "#ffffff" : "#04B7B1");
const setSortingIconColor = () => (localGetItem("theme") === "dark" ? "#ffffff" : "#04B7B1");
const setTableCard = () => (localGetItem("theme") === "dark" ? "#17202A" : "#ffffff");
const setSecondaryColor = () => (localGetItem("theme") === "dark" ? "#ffffff" : "#04B7B1");
const setPopupBackground = () => (localGetItem("theme") === "dark" ? "#566573" : "#ffffff");
const setIconColor = () => (localGetItem("theme") === "dark" ? "#ffffff" : "#04B7B1");
const setHelperText = () => (localGetItem("theme") === "dark" ? "#ffffff" : "#000000");
const setCompBgColor = () => "#F5F8F7";
const setThemeLightClr = () => "#E4F2F0";

export const Colors = {
    TableHeaderBarBGColor: setTableHeaderColor(),
    ThemeColor: setThemeColor(),
    SecondaryColor: setSecondaryColor(),
    TableHeaderTextColor: setTableHeadTextColor(),
    TableProfilDetails: setTableDataTextColor(),
    HoverColor: setHoverColor(),
    BgColor: setBgColor(),
    ListItems: setListItemsColor(),
    ListIcons: setListIconColor(),
    IconCircleBgColor: setIconBgIcon(),
    TableBody: setTableBody(),
    ContrastText: setConstrastColor(),
    HelperText: setHelperText(),
    TextColor: setTextColor(),
    HighlightColor: setHighlightColor(),
    TabsColor: settabsColor(),
    pageTopBackground: setTopDivbackgound(),
    PagiantionTxtColor: setPagiantionTxtColor(),
    SortIconColor: setSortingIconColor(),
    TableCard: setTableCard(),
    PopupBackground: setPopupBackground(),
    IconColor: setIconColor(),
    ComponentBgColor: setCompBgColor(),
    ThemeLightColor: setThemeLightClr(),
    SideMenuAndMainHeadingText: "#2F2A53",
    Tabs: "#1A1A1A",
    DateFilter: "#696969",
    CardMAinHeading: "#04B7B1",
    SideMenuBranchHeading: "#2F2A53",
    DashBoardCardContents: "#696969",
    SelectedItemsBGColor: "#04B7B1",
    SelectedItemsBGText: "#FFFFFF",
    TableContentsTextColor: "#2E2E2E",
    HeaderBarBGColor: "#EDFFFE",
    HeaderBarTextColor: "#1A1A1A",
    defaulttheme: "#04B7B1",
    green: "#43C64F",
    black: "#1a1917",
    themeBlue: "#262941",
    themePink: "#F25364",
    white: "#ffffff",
    red: "#F1584A",
    themeDark: "#04b7b1",
    disableLabelColor: "#A9A9A9",
    themeBackgroud: "#04b7b1",
    Primary: "#04B7B1",
    SecondaryFill: "#E4F2F0",
    Background: "#F5F8F7",
    configHomeBg: "#F5F8F7",
    SecondaryText: "#616161",
    HeadText: "#202020",
};
